module.exports = __webpack_public_path__ + "static/media/splash--view-img.7daae7ff.png";